module.exports = __webpack_public_path__ + "static/media/spinner.c7d24628.gif";